module.exports = __webpack_public_path__ + "static/media/New_Series_3_Ep3_The_Waste_Chain_Desktop.18628ef3.jpg";